import { JobPaymentInfo } from "~/types";

export const formatSalary = (salary: number): string => {
  const roundedSalary = Math.floor(salary / 100) * 100;
  const inMan = roundedSalary / 10000;
  const thousands = Math.floor(roundedSalary / 1000) % 10;

  if (thousands === 0) {
    return `${Math.floor(inMan)}万`;
  } else {
    const oneDecimal = Math.floor(inMan * 10) / 10;
    return `${oneDecimal.toFixed(1)}万`;
  }
};

export const formatPayment = ({
  salary_min,
  salary_max,
  salary_display_type,
}: JobPaymentInfo): string => {
  if (salary_display_type === 2 && salary_max > 0) {
    return `${formatSalary(salary_min)}〜${formatSalary(salary_max)}`;
  }
  return formatSalary(salary_min);
};
